import React from 'react';
import { Outlet } from 'react-router';
import { Container, Stack, Typography } from '@mui/material';
import { HelpManageTopicsPage } from './HelpManageTopicsPage';
import { HelpManageArticlesPage } from './HelpManageArticlesPage';

/** Page whiich take care of managing article in the help center */
export const HelpManagePage = () => {
    return <Container sx={{ p: 2 }}>
        <Typography variant='h1'>Manage Help Center</Typography>
        <Outlet />
    </Container>;
}

/** The initial page to show in the index of the help center manage section */
export const HelpManageNewPage = () => {
    return (
        <Stack direction={'column'}>
            <HelpManageTopicsPage />
            <HelpManageArticlesPage />
        </Stack>
    )
}

